'use client'

import { useTranslations } from '@/lib/next-shim'
import { UploadButton } from '@/shared/ui/buttons/UploadButton'
import { useExpertiseFiles } from '../model/useExpertiseFiles'
import { ExpertiseFile } from '../lib/expertise-detail.types'
import { FileItem } from './FileItem'

type FilesSectionProps = {
  files: ExpertiseFile[]
  expertiseId: string
}

export function FilesSection({ files, expertiseId }: FilesSectionProps) {
  const t = useTranslations()
  const { downloadingKey, uploadFile, downloadFile } = useExpertiseFiles(expertiseId)

  return (
    <div>
      <h2 className="mb-2 text-sm font-medium text-gray-500">{t('account.expertises.files')}</h2>
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        {files.length > 0 && (
          <ul className="mb-4 space-y-1">
            {files.map((file) => (
              <FileItem key={file.key} file={file} isDownloading={downloadingKey === file.key} onDownload={downloadFile} />
            ))}
          </ul>
        )}
        <div className="relative">
          <UploadButton onFileUpload={uploadFile} />
        </div>
      </div>
    </div>
  )
}
